module.exports = __webpack_public_path__ + "static/FAVT_banner_tablet.ed923868.png";


//////////////////
// WEBPACK FOOTER
// ./src/templates/assets/FAVT_banner_tablet.png
// module id = 991
// module chunks = 101932004231744